import {  toast } from 'react-toastify';

class Toaster extends toast{
    constructor(props){
        super(props)
    }

}

export default Toaster